import { render, staticRenderFns } from "./RedeemGift.vue?vue&type=template&id=4f402483&"
import script from "./RedeemGift.vue?vue&type=script&lang=js&"
export * from "./RedeemGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports